<p-select class="brand-selector" optionLabel="label" optionValue="value" ariaLabel="Brand" [options]="options" [ngModel]="brand()" (ngModelChange)="onBrandChange($event)">
  <ng-template let-item pTemplate="selectedItem">
    @if (item) {
      <span class="brand-option">
        <img class="brand-option-icon" alt="" [src]="item.icon" />
        <span>{{ item.label }}</span>
      </span>
    }
  </ng-template>
  <ng-template let-item pTemplate="item">
    <span class="brand-option">
      <img class="brand-option-icon" alt="" [src]="item.icon" />
      <span>{{ item.label }}</span>
    </span>
  </ng-template>
</p-select>
